/* MARU MORI :: product page
   Segmented sizes with nothing preselected, add button and wallet buttons held
   until a size is chosen, story trimmed to three paragraphs with Read more,
   desktop panel kept reachable, mobile name and price on one line. */
(function () {
  if (window.mmProduct) return;
  window.mmProduct = true;

  var WAIST = { S: '28', M: '31', L: '34', XL: '37', '2XL': '40' };
  var ALIAS = { 'black-evening-boxer-3-pack': 'the-evening-boxer-black' };
  var desktop = window.matchMedia('(min-width: 990px)');

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* ---------------- Product page ---------------- */

  function initProduct() {
    var info = document.querySelector('.product__info-container');
    if (!info) return;
    var picker = info.querySelector('variant-radios');
    if (picker) initSizes(info, picker);
    initStory(info);
    initNamePrice(info);
    fitPanel();
    window.addEventListener('resize', debounce(function () {
      initNamePrice(info);
      fitPanel();
    }, 150));
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(fitPanel);
    setTimeout(fitPanel, 800);
  }

  function initSizes(info, picker) {
    var fieldsets = Array.prototype.filter.call(picker.querySelectorAll('fieldset'), function (fs) {
      return fs.querySelector('input[type="radio"]');
    });
    if (!fieldsets.length) return;

    var radios = picker.querySelectorAll('input[type="radio"]');
    var formId = radios[0].getAttribute('form');

    /* Nothing preselected: every visit starts with a deliberate choice */
    Array.prototype.forEach.call(radios, function (r) {
      r.checked = false;
      r.removeAttribute('checked');
    });

    function getForm() {
      return (formId && document.getElementById(formId)) || info.querySelector('form[action*="/cart/add"]');
    }
    function getButton() {
      var f = getForm();
      return (f && f.querySelector('button[name="add"]')) || info.querySelector('button[name="add"]');
    }
    function chosen() {
      var vals = [];
      for (var i = 0; i < fieldsets.length; i++) {
        var c = fieldsets[i].querySelector('input[type="radio"]:checked');
        if (!c) return null;
        vals.push(c.value);
      }
      return vals;
    }

    fieldsets.forEach(function (fs) {
      var name = fs.querySelector('.product-form__group-name');
      if (name && !name.querySelector('.mm-readout')) {
        var ro = document.createElement('span');
        ro.className = 'mm-readout';
        name.appendChild(ro);
      }
      var group = fs.querySelector('.product-form__controls-group');
      if (group && !fs.querySelector('.mm-size-msg')) {
        var msg = document.createElement('p');
        msg.className = 'mm-size-msg';
        msg.setAttribute('role', 'status');
        msg.setAttribute('aria-live', 'polite');
        group.insertAdjacentElement('afterend', msg);
      }
    });

    var checkout = info.querySelector('.product-form__checkout');
    if (checkout && !checkout.querySelector('.mm-pay-shield')) {
      checkout.style.position = 'relative';
      var shield = document.createElement('button');
      shield.type = 'button';
      shield.className = 'mm-pay-shield';
      shield.setAttribute('aria-label', 'Choose a size first');
      shield.addEventListener('click', nudge);
      checkout.appendChild(shield);
    }

    function setButton() {
      var b = getButton();
      if (!b) return;
      var span = b.querySelector('span');
      if (!span) return;
      if (b.hasAttribute('disabled')) return; /* sold out: keep the theme's waitlist text */
      var vals = chosen();
      var want = vals ? 'Add to bag · ' + vals.join(' / ') : 'Select a size';
      if (span.textContent.trim() !== want) span.textContent = want;
    }

    function update() {
      var vals = chosen();
      info.classList.toggle('mm-needs-size', !vals);
      fieldsets.forEach(function (fs) {
        var c = fs.querySelector('input[type="radio"]:checked');
        var ro = fs.querySelector('.mm-readout');
        if (ro) {
          ro.textContent = c
            ? ' · ' + c.value + (WAIST[c.value] ? ' · Waist ' + WAIST[c.value] + ' in' : '')
            : '';
        }
        if (c) {
          fs.classList.remove('mm-nudge');
          var m = fs.querySelector('.mm-size-msg');
          if (m) m.textContent = '';
        }
      });
      setButton();
    }

    function nudge() {
      var target = fieldsets.filter(function (f) {
        return !f.querySelector('input[type="radio"]:checked');
      })[0] || fieldsets[0];
      target.classList.remove('mm-nudge');
      void target.offsetWidth;
      target.classList.add('mm-nudge');
      var m = target.querySelector('.mm-size-msg');
      if (m) m.textContent = 'Choose a size';
      var r = target.getBoundingClientRect();
      if (r.top < 90 || r.bottom > window.innerHeight - 20) {
        target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }

    document.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('button[name="add"]');
      if (!b || !info.contains(b)) return;
      if (!chosen()) {
        e.preventDefault();
        e.stopImmediatePropagation();
        nudge();
      }
    }, true);

    document.addEventListener('submit', function (e) {
      if (e.target === getForm() && !chosen()) {
        e.preventDefault();
        e.stopImmediatePropagation();
        nudge();
      }
    }, true);

    picker.addEventListener('change', function () {
      update();
      setTimeout(setButton, 350);
      setTimeout(setButton, 900);
    });

    /* The theme rewrites the button after a variant change; put our label back */
    var pending = false;
    new MutationObserver(function () {
      if (pending) return;
      pending = true;
      requestAnimationFrame(function () {
        pending = false;
        setButton();
      });
    }).observe(info, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['disabled'] });

    update();
    document.documentElement.classList.add('mm-sizes-ready');
  }

  function initStory(info) {
    var d = info.querySelector('.product__description');
    if (!d || d.getAttribute('data-mm-story')) return;
    var count = 0;
    var rest = [];
    Array.prototype.forEach.call(d.children, function (c) {
      if (count >= 3) rest.push(c);
      if (c.textContent.trim()) count++;
    });
    if (!rest.filter(function (c) { return c.textContent.trim(); }).length) return;
    d.setAttribute('data-mm-story', '1');
    rest.forEach(function (c) { c.classList.add('mm-story-rest'); });
    d.classList.add('mm-story', 'mm-story--clamped');
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'mm-story-more';
    b.textContent = 'Read more';
    b.setAttribute('aria-expanded', 'false');
    if (d.id) b.setAttribute('aria-controls', d.id);
    d.insertAdjacentElement('afterend', b);
    b.addEventListener('click', function () {
      var open = d.classList.contains('mm-story--clamped');
      d.classList.toggle('mm-story--clamped', !open);
      b.textContent = open ? 'Read less' : 'Read more';
      b.setAttribute('aria-expanded', open ? 'true' : 'false');
      fitPanel();
    });
  }

  /* Desktop: the details column is pinned. When it is taller than the
     screen (story opened, small laptop), let it scroll until its last
     line is visible, then pin. When it fits, the theme centres it. */
  function fitPanel() {
    var p = document.querySelector('.product__info-main');
    if (!p) return;
    if (!desktop.matches) {
      p.style.top = '';
      return;
    }
    var h = p.offsetHeight;
    var vh = window.innerHeight;
    p.style.top = h > vh ? (vh - h - 24) + 'px' : '';
  }

  /* Mobile: name and price share a line over the hairline */
  function initNamePrice(info) {
    var row = info.querySelector('.mm-name-row');
    if (desktop.matches) {
      if (row) document.documentElement.classList.remove('mm-price-inline');
      return;
    }
    if (row) {
      document.documentElement.classList.add('mm-price-inline');
      return;
    }
    if (document.getElementById('mmElseBtn')) return; /* the Elsewhere switch owns that corner */
    var h1 = info.querySelector('h1');
    var pw = info.querySelector('.price-wrapper');
    if (!h1 || !pw) return;
    var item = pw.querySelector('.price-item--regular') || pw.querySelector('.price-item') || pw;
    var txt = item.textContent.replace(/\s+/g, ' ').trim();
    if (!txt) return;
    row = document.createElement('div');
    row.className = 'mm-name-row';
    h1.parentNode.insertBefore(row, h1);
    row.appendChild(h1);
    var price = document.createElement('span');
    price.className = 'mm-name-price';
    price.textContent = txt;
    row.appendChild(price);
    document.documentElement.classList.add('mm-price-inline');
  }

  function debounce(fn, ms) {
    var t;
    return function () {
      clearTimeout(t);
      t = setTimeout(fn, ms);
    };
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProduct);
  } else {
    initProduct();
  }
})();